import * as React from 'react';

const BannerContext = React.createContext<{
  height: number;
  setHeight: (height: number) => void;
}>(undefined as never);

export { BannerContext };
